var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 33,
    viewBox: "0 0 17 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.27881 31.5447V25.4785",
    stroke: "#8799C5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.63965,
    width: 7.27939,
    height: 21.8382,
    rx: 3.6397,
    fill: "#8799C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5588 18.1982C15.5588 20.1289 14.7918 21.9804 13.4267 23.3455C12.0615 24.7107 10.21 25.4776 8.27939 25.4776C6.34878 25.4776 4.49724 24.7107 3.13208 23.3455C1.76693 21.9804 1 20.1289 1 18.1982",
    stroke: "#8799C5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.3ed294584bcdcf8f213a460de0b7f634.svg";
export { ForwardRef as ReactComponent };